<template>
  <form-element v-if="hotspot" :hotspot="hotspot" :translate-labels="translateLabels"/>
</template>

<script setup>
import { computed } from 'vue'
import { usePlayerStore } from '@/playerVue3/storage/storePlayer'
import { useTranslation } from '@/composables/useTranslation'
import FormElement from '@/playerVue3/components/form/form-element.vue'

const store = usePlayerStore()
const { translate } = useTranslation()

const hotspot = computed(() => {
  return store.registerHotspotData
})

const translateLabels = computed(() => {
  return {
    textOther: translate('label.other'),
    textSelect: translate('label.select'),
    textMandatoryFields: translate('label.mandatory_fields'),
    textButtonSubmit: translate('label.submit'),
    textBack: translate('label.back'),
    textNext: translate('label.next'),
  }
})
</script>